import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import ErrorIcon from '@wix/da-ds/pkg/Icons/24x24/Error';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { canPeek } from '../../utils';
import { CommentContext } from '../../CommentContext';
import CommentDataAttrDiv from '../../lego/CommentDataAttrDiv';
import s from './SpamView.scss';

interface Props {}

const SpamView: React.FC<Props> = () => {
  const { t } = useTranslation();
  const { setPeeking, comment } = useContext(CommentContext);

  const isPeekable = canPeek(comment);
  const Tag = isPeekable ? PlainButtonOrLink : 'div';

  return (
    <CommentDataAttrDiv className={s['root']}>
      <Tag
        className={s['spam']}
        onClick={isPeekable ? () => setPeeking(true) : undefined}
      >
        <span className={s['spam-text']}>
          <ErrorIcon className={s['hidden-icon']} />
          {t('comment.visibility.spam')}
        </span>
      </Tag>
    </CommentDataAttrDiv>
  );
};
SpamView.displayName = 'SpamView';

export default SpamView;
